// extracted by mini-css-extract-plugin
module.exports = {"project":"styles_project__3mVR9","header":"styles_header__1pv-s","footer":"styles_footer__180W0","title":"styles_title__3I36O"};